import {GenericItemsUtils, Grid, IGetAllParams, GenericItemsForm, MuiDataGrid, MuiIcons, Toc as TocIcon, Typography} from "@leap4/frontend";
import {BaseGenericItemsStore} from "@leap4/frontend";
import {IPartner} from "@leap4/entities-discrepancy-common"
import {baseBackendRoute} from "../../../config/generals";
import {urlService} from "../../routing/urlsService"
import * as React from "react";
import {RootState} from "../../../interfaces/root-state.interface";
import {connect, ConnectedProps} from "react-redux";
import {Server} from "@leap4/auth";

const {ReportProblem: ReportProblemIcon} = MuiIcons;
type GridColDef = MuiDataGrid.GridColDef;

const fields = {
    name: 1,
    // side: 1,
    created: 1,
    updated: 1,
    isActive: 1,
}

const getParams: IGetAllParams = {
    fields,
}

let columns: GridColDef[];
let store: BaseGenericItemsStore<IPartner & { _id: string, isActive: boolean }>

function setStoreAndColumns() {
    const storeAndColumns = GenericItemsUtils.GenerateDefaultStoreAndColumns({
        baseUrl: baseBackendRoute + "/partners/demand",
    }, fields, {
        name: {editLinkFunc: (id: string) => urlService.editPartner(id)},
        isActive: {},
        updated: {},
        created: {}
    })

    store = storeAndColumns.store;
    columns = storeAndColumns.columns;

}
const mapStateToProps = (state: RootState) => ({
    selectedOrganization: state.auth.selectedOrganizationId
});


const connector = connect(mapStateToProps);
type PropsFromRedux = ConnectedProps<typeof connector>;

 const _PartnersDemandTable = (props:PropsFromRedux) => {
    setStoreAndColumns();

     const lastChosenOrganization = localStorage.getItem(Server.headers.X_ORGANZIZATION).split('-')
     if (lastChosenOrganization.length > 1) {
         return (
             <>
                 <Grid item lg={4} xl={3} margin={2.5}>
                     <ReportProblemIcon color={"info"} style={{ fontSize: '500%' }}></ReportProblemIcon>
                 </Grid>
                 <Grid item>
                     <Typography variant="h5" fontFamily={"Quicksand"} fontWeight={600}>
                         {'\nThis page available for one organization picked only!'}
                     </Typography>
                 </Grid>
             </>
         )
     }

    return (
        <GenericItemsForm
            columns={columns}
            store={store}
            breadcrumbs={{
                link: urlService.partnersSupply(),
                text: "Demand Partners Dashboard",
                icon: <TocIcon />
            }}
            organization={props.selectedOrganization}
            getAllParams={getParams}
            createButton={{
                to: urlService.createPartner(),
                text: "Create Partner ".toUpperCase()
            }}
            tableProps={{
                pageSize:50
            }}
        />
    );
};

 export const PartnersDemandTable = connector(_PartnersDemandTable)


